import { NgModule } from '@angular/core';
import { SurveyServiceModule } from './services';

@NgModule({
  imports:[SurveyServiceModule],
  exports:[SurveyServiceModule]
})
export class SurveyCoreModule {
  static forRoot (env:{
    serverHost:string,
    firebase:any,
    schoolbelleLoginFrontHost:string
  }) {
    return {
      ngModule:SurveyServiceModule,
      providers:[
        ...SurveyServiceModule.forRoot(env).providers,
      ]
    }

  }
}
